export default __webpack_public_path__ + "static/media/goshen69.0d8a26c6.jpg";